import React from 'react';
import { useNavigate } from 'react-router-dom';
import './TopPicksRow.css';
import { FaPassport, FaCode, FaBriefcase, FaCertificate, FaProjectDiagram, FaEnvelope, FaMusic, FaBook } from 'react-icons/fa';

type ProfileType = 'recruiter' | 'developer' | 'stalker' | 'adventure';

interface TopPicksRowProps {
  profile: ProfileType;
}

const topPicksConfig = {
  recruiter: [
    { title: "Work Permit", imgSrc: "https://i.pinimg.com/736x/74/6e/46/746e46bc2a8574f42c24d675e5814d8b.jpg", icon: <FaPassport />, route: "/work-permit" },
    { title: "Skills", imgSrc: "https://i.pinimg.com/736x/a2/6c/1f/a26c1f5b46081c2cc9ee79068f1ee205.jpg", icon: <FaCode />, route: "/skills" },
    { title: "Experience", imgSrc: "https://i.pinimg.com/736x/f6/ed/c3/f6edc3cb7515bf9259a129fe36607d35.jpg", icon: <FaBriefcase />, route: "/work-experience" },
    { title: "Certifications", imgSrc: "https://i.pinimg.com/736x/68/e1/df/68e1df6774e867bd2f2f24f4ab668283.jpg", icon: <FaCertificate />, route: "/certifications" },
    { title: "Projects", imgSrc: "https://i.pinimg.com/736x/3e/ee/c4/3eeec409466bb442adeed941ba352396.jpg", icon: <FaProjectDiagram />, route: "/projects" },
    { title: "Contact Me", imgSrc: "https://i.pinimg.com/1200x/68/02/67/680267a5bad9dcef14b1b5be05a40e77.jpg", icon: <FaEnvelope />, route: "/contact-me" }
  ],
  developer: [
    { title: "Skills", imgSrc: "https://i.pinimg.com/736x/a2/6c/1f/a26c1f5b46081c2cc9ee79068f1ee205.jpg", icon: <FaCode />, route: "/skills" },
    { title: "Projects", imgSrc: "https://i.pinimg.com/736x/3e/ee/c4/3eeec409466bb442adeed941ba352396.jpg", icon: <FaProjectDiagram />, route: "/projects" },
    { title: "Experience", imgSrc: "https://i.pinimg.com/736x/f6/ed/c3/f6edc3cb7515bf9259a129fe36607d35.jpg", icon: <FaBriefcase />, route: "/work-experience" },
    { title: "Certifications", imgSrc: "https://i.pinimg.com/736x/68/e1/df/68e1df6774e867bd2f2f24f4ab668283.jpg", icon: <FaCertificate />, route: "/certifications" },
    { title: "Contact Me", imgSrc: "https://i.pinimg.com/736x/63/65/dd/6365ddcbf89631aeef56e67cc2ba0ed3.jpg", icon: <FaEnvelope />, route: "/contact-me" }
  ],
  stalker: [
   { title: "Contact Me", imgSrc: "https://i.pinimg.com/736x/63/65/dd/6365ddcbf89631aeef56e67cc2ba0ed3.jpg", route: "/contact-me", icon: <FaEnvelope /> },
   { title: "Projects", imgSrc: "https://i.pinimg.com/736x/3e/ee/c4/3eeec409466bb442adeed941ba352396.jpg", icon: <FaProjectDiagram />, route: "/projects" },
   { title: "Experience", imgSrc: "https://i.pinimg.com/736x/f6/ed/c3/f6edc3cb7515bf9259a129fe36607d35.jpg", icon: <FaBriefcase />, route: "/work-experience" },
   { title: "Certifications", imgSrc: "https://i.pinimg.com/736x/68/e1/df/68e1df6774e867bd2f2f24f4ab668283.jpg", icon: <FaCertificate />, route: "/certifications" }
  ],
  adventure: [
    { title: "Music", imgSrc: "https://i.pinimg.com/736x/c1/9a/96/c19a9667056d1c63cdb28697abb8de56.jpg", route: "/music", icon: <FaMusic /> },
    { title: "Projects", imgSrc: "https://i.pinimg.com/736x/3e/ee/c4/3eeec409466bb442adeed941ba352396.jpg", route: "/projects", icon: <FaProjectDiagram /> },
    { title: "Reading", imgSrc: "https://i.pinimg.com/1200x/2c/7c/2c/2c7c2c09a61324c028b550ffb758f14e.jpg", route: "/reading", icon: <FaBook /> },
    { title: "Contact Me", imgSrc: "https://i.pinimg.com/736x/63/65/dd/6365ddcbf89631aeef56e67cc2ba0ed3.jpg", route: "/contact-me", icon: <FaEnvelope /> },
    { title: "Certifications", imgSrc: "https://i.pinimg.com/736x/68/e1/df/68e1df6774e867bd2f2f24f4ab668283.jpg", route: "/certifications", icon: <FaCertificate /> }
  ]
};


const TopPicksRow: React.FC<TopPicksRowProps> = ({ profile }) => {
  const navigate = useNavigate();
  const topPicks = topPicksConfig[profile];

  return (
    <div className="top-picks-row">
      <h2 className="row-title">Today's Top Picks for {profile}</h2>
      <div className="card-row">
      {topPicks.map((pick, index) => (
          <div 
            key={index} 
            className="pick-card" 
            onClick={() => navigate(pick.route)}
            style={{ animationDelay: `${index * 0.2}s` }} // Adding delay based on index
          >
            <img src={pick.imgSrc} alt={pick.title} className="pick-image" />
            <div className="overlay">
              <div className="pick-label">{pick.title}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TopPicksRow;
